import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dbindices } from '../../core/entities/dbindices.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DbindicesService {
    readonly BASE: any = PETICIONES.dbindices;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los dbindices
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un dbindices por su id
   */
  public findById(id: number): Observable<any> {
    let idbindices: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idbindices).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un dbindices en la base de datos
   */
  public postDbindice(dbindices: Dbindices): Observable<any> {
    const json = JSON.stringify(dbindices);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postDbindices, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un dbindices en la base de datos
   */
  public deleteDbindice(dbindices: Dbindices): Observable<any> {
    let iddbindices: string = (dbindices.id !== undefined && dbindices.id !== null ? dbindices.id + "" : "");
    return this.http.get(this.BASE.deleteDbindices + "/" + iddbindices).pipe(delay(DELAY));
  }

}